import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@animech/ui";
import * as Styled from "ui/components/panels/sidebar/sidebar.style";
import { KeyBindings, useKeyBindings } from "hooks/keybindings";
import { useAppDispatch, useAppSelector, selectors, actions } from "store";
import { NodeComponentType, SelectionDecentralizedPumpType, } from "store/types";
var supportedKeyboardKeys = [KeyBindings.DELETE];
/* Deletes the selection with the Delete key, and with a button once several
 * things are selected (a single node has the delete button on its canvas
 * overlay, a single tube in its menu). */
export var DeleteSelection = function (_a) {
    var nodes = _a.nodes, edges = _a.edges;
    var t = useTranslation().t;
    var dispatch = useAppDispatch();
    var isMultiSelecting = useAppSelector(selectors.selectIsMultiSelecting);
    var selectionFilter = useAppSelector(selectors.selectSelectionFilter);
    /* A decentral pump is part of its grip position: deleting it would take
     * the cup with it. */
    var disabled = selectionFilter === SelectionDecentralizedPumpType;
    var nodeIds = useMemo(function () {
        return nodes
            .filter(function (node) { return node.type !== NodeComponentType.FEED_PRESSURE_POINT; })
            .map(function (node) { return node.id; });
    }, [nodes]);
    var edgeIds = useMemo(function () { return edges.map(function (edge) { return edge.id; }); }, [edges]);
    var count = nodeIds.length + edgeIds.length;
    useKeyBindings({
        keys: supportedKeyboardKeys,
        disabled: disabled,
        nodeIds: nodeIds,
        edgeIds: edgeIds,
    });
    if (!isMultiSelecting || disabled || count === 0)
        return null;
    return (_jsx(Styled.SidebarSection, { children: _jsx(Button, { appearance: "ghost", color: "alert", onClick: function () { return dispatch(actions.deleteEntities({ nodeIds: nodeIds, edgeIds: edgeIds })); }, children: t("sidebar.delete_selection", { count: count }) }) }));
};
